/** The app's addresses for the monthly loop and the pages it links to (one place to change). */
const nowMonth = () => { const n = new Date(); return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, '0')}`; };

export const DESK = {
  home: (month?: string) => (month ? `/?month=${month}` : '/'),
  plan: (month?: string) => `/month/${month || nowMonth()}`,
  prepare: (month?: string) => `/month/${month || nowMonth()}/prepare`,
  posts: (month?: string) => `/month/${month || nowMonth()}/posts`,
  newPost: (month?: string) => `/month/${month || nowMonth()}/posts/new`,
  makePost: (month: string, postId: string) => `/month/${month}/posts/${postId}/make`,
  production: (month?: string, productionId?: string) => `/month/${month || nowMonth()}/production${productionId ? `?c=${productionId}` : ''}`,
  review: (productionId: string) => `/campaigns/${productionId}/review`,
  /** A post's review page (its own address, so the menu shows Posts, not Campaigns). */
  postReview: (productionId: string) => `/posts/${productionId}`,
  campaignPage: (productionId: string, tab: 'review' | 'launch' | 'results' = 'review') => `/campaigns/${productionId}/review${tab === 'review' ? '' : `/${tab}`}`,
  strategy: '/strategy',
  business: '/business',
  start: '/start',
  calendar: '/calendar',
  needs: '/needs',
  // Existing screens the desk links out to (reused, never rebuilt)
  campaign: (conversationId: string) => `/campaigns/${conversationId}`,
  campaignResults: (conversationId: string) => `/campaigns/${conversationId}/analytics`,
  campaigns: '/campaigns',
  newCampaign: '/campaigns/new',
  results: '/results',
  media: '/media?view=planning',
  studio: '/ad-studio',
  leads: '/leads',
  settings: '/settings',
  /** A business's settings; 'active' stands for the business you're working in. */
  businesses: '/settings/businesses',
  businessSettings: (orgId: string = 'active', section: 'connections' | 'team' | 'notifications' | 'limit' = 'connections') => `/settings/businesses/${orgId}/${section}`,
  team: '/settings/businesses/active/team',
  billing: '/settings/billing',
} as const;
